"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showRefinedInterpreter = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var function_1 = require("fp-ts/function");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
/**
 *  @since 0.0.1
 */
exports.showRefinedInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.ShowURI,
    refined: function (getShow, _ref, name, config) { return function (env) {
        return function_1.pipe(getShow(env).show, function (show) { return new hkt_1.ShowType({ show: function (x) { return "<" + name + ">(" + config_1.showApplyConfig(config)(show, env, { show: show }).show(x) + ")"; } }); });
    }; },
    constrained: function (getShow, _ref, name, config) { return function (env) {
        return function_1.pipe(getShow(env).show, function (show) { return new hkt_1.ShowType({ show: function (x) { return "<" + name + ">(" + config_1.showApplyConfig(config)(show, env, { show: show }).show(x) + ")"; } }); });
    }; }
}); });
